// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ProductType;
(function (ProductType) {
    ProductType[ProductType["General"] = 0] = "General";
    ProductType[ProductType["Intraday"] = 1] = "Intraday";
    ProductType[ProductType["Delivery"] = 2] = "Delivery";
    ProductType[ProductType["CorporateAction"] = 4] = "CorporateAction";
})(ProductType || (ProductType = {}));
export function getProductTypeKey(productType) {
    switch (productType) {
        case ProductType.General:
            return 'General';
        case ProductType.Intraday:
            return 'Intraday';
        case ProductType.Delivery:
            return 'Delivery';
        case ProductType.CorporateAction:
            return 'CorporateAction';
        default:
            return null;
    }
}
export const ORDER_PARAMETER_PRODUCT_TYPE = 'productType';
